import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {UserYearSelector} from '@/features/users/components/user-year-selector/UserYearSelector'
import {UserAbsenceIncopatibilityFormValidationSchema} from '@/features/users/types'

export const UserAbsenceIncopatibilityForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserAbsenceIncopatibilityFormValidationSchema>()

    return (
        <Grid columns={6} fullWidth>
            <GridItem startColumn={1} endColumn={4}>
                <Controller
                    control={form.control}
                    name="absenceOfIncompatibilityLastVerify"
                    render={({field}) => (
                        <UserYearSelector
                            label={t('commons:last_verify_date')}
                            onChange={field.onChange}
                            value={field.value ?? undefined}
                            errorMessage={form.formState.errors.absenceOfIncompatibilityLastVerify?.message}
                            yearsFromNow={-91}
                            reverseOrder
                        />
                    )}
                />
            </GridItem>
        </Grid>
    )
}
